import { RuleResult } from 'types/DeclarationP5'
import { CL505_WITHOUT_ZIP_COUNTRIES } from 'shared/ncts/common/constants'
import { hasText } from 'shared/lib/common-util'
import { removePrefix } from 'shared/ncts/common/classifier-util'

const C0505Validator = {
  validatePostcodeRequirement: (country: string | null | undefined): RuleResult => {
    if (country != null && hasText(country) && CL505_WITHOUT_ZIP_COUNTRIES.includes(removePrefix(country, 'COUNTRY_') ?? '')) {
      return 'OPTIONAL'
    }

    return 'REQUIRED'
  },
} as const

export default C0505Validator
